import { useState, useRef, useEffect } from "react";

export const useAnimatedNumber = (value: number) => {
  const [displayValue, setDisplayValue] = useState(value);
  const animationRef = useRef<number>();

  useEffect(() => {
    // Cancel any existing animation
    if (animationRef.current) {
      cancelAnimationFrame(animationRef.current);
    }

    const startValue = displayValue;
    const difference = value - startValue;
    const startTime = performance.now();
    const duration = 200; // Animation duration in milliseconds

    const animateValue = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      if (progress < 1) {
        const currentValue = Math.round(startValue + difference * progress);
        setDisplayValue(currentValue);
        animationRef.current = requestAnimationFrame(animateValue);
      } else {
        setDisplayValue(value);
      }
    };

    animationRef.current = requestAnimationFrame(animateValue);

    // Cleanup function to cancel animation on unmount or when value changes
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [value]); // Remove displayValue dependency

  return displayValue;
};
